import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Dialog } from '@material-ui/core';
import PageTitle from '~/components/PageTitle';
import { EAA_Item, EAA_ItemContainer, EAA_Row, EAA_TitleText, EAA_Btn, EAA_ErrorText, EAA_Select, EAA_Memo } from '~/components/EditAndAddItem';
import { leftColor, rightColor } from '~/components/EditAndAddItem/common';
import Supple from './Supple';

const modeInfo = {
  add: {
    title: '新增事由說明',
  },
  edit: {
    title: '編輯事由說明',
  },
  view: {
    title: '檢視事由說明',
  },
};

const titleWidth = 140;
const errorLeft = 20 + titleWidth;

class AddAndEdit extends Component {
  constructor (props) {
    super(props);
    this.state = {
      data: JSON.parse(JSON.stringify(props.data)),
      old_data: JSON.parse(JSON.stringify(props.data)),
      mode: '',
      canSend: true,
      errorAry: [],
    };
  }

  _onClose=() => {
    this.props._onClose();
  }

  changeData=({ label = '', data = '' }, func = () => {}) => {
    const { data: body } = this.state;
    const newBody = {
      ...body,
      [label]: data,
    };
    this.setState({ data: newBody }, func);
  }

  getSendBody=() => {
    const { data } = this.state;
    const body = {
      eco_doc_date: data.eco_doc_date || '',
      eco_doc_num: data.eco_doc_num || '',
      eco_doc_upload_files: data.eco_doc_upload_files || [],
      meet_date: data.meet_date || '',
      meet_num: data.meet_num || '',
      meet_doc_upload_files: data.meet_doc_upload_files || [],
      supple_date: data.supple_date || '',
      supple_doc_num: data.supple_doc_num || '',
      supple_doc_upload_files: data.supple_doc_upload_files || [],
      supple_desc: data.supple_desc || '[]',
      other_event: data.other_event || '[]',
    };
    return body;
  }

  add=() => {
    const { onChange } = this.props;
    onChange(this.state.data);
    this._onClose();
  }

  goToCheck=() => this.setState({ mode: 'check' }, () => this.filterError())
  goToEdit=() => this.setState({ mode: '', errorAry: [] });
  edit=() => {
    const { onChange } = this.props;
    onChange(this.state.data);
    this._onClose();
  }

  filterError=() => {
    const { data = {} } = this.state;
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const errorAry = [
      returnInputValue(data.extend_desc) === '', // 0
      returnInputValue(data.extend_reason) === '', // 1
      returnInputValue(data.extend_rule) === '', // 2
    ];
    this.setState({ errorAry });
    return errorAry.indexOf(true) !== -1;
  }

  renderDialog=() => {
    const { mode = '', ExtendReason = [], ExtendRule = [] } = this.props;
    const { data = {}, old_data = {}, canSend, errorAry } = this.state;
    const isCheck = this.state.mode === 'check';
    const disabled = mode === 'view' || isCheck;
    const checkChange = label => isCheck ? (data[label] || '') !== (old_data[label] || '') : false;
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const allRight = errorAry.indexOf(true) === -1;
    return (
      <div style={{ minWidth: 768, width: '80%', maxHeight: '80%', backgroundColor: 'white', borderRadius: 39, padding: 20, overflowY: 'auto' }}>
        <PageTitle text={modeInfo[mode].title} center />

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} bol text='展延事由' haveChange={checkChange('extend_desc')} />
              <EAA_Memo disabled={disabled} displayBorder value={returnInputValue(data.extend_desc)} onChange={data => this.changeData({ label: 'extend_desc', data })} />
            </EAA_ItemContainer>
            {errorAry[0] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入' />}
          </EAA_Item>
        </EAA_Row>

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} bol text='展延事由' subtitle='對應款次' subtitleColor='black' haveChange={checkChange('extend_reason') || checkChange('extend_rule')} />
              <EAA_Select disabled={disabled} displayBorder list={ExtendReason} value={returnInputValue(data.extend_reason)} onChange={data => this.changeData({ label: 'extend_reason', data })} />
            </EAA_ItemContainer>
            {errorAry[1] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇' />}
          </EAA_Item>
          <EAA_Item />
        </EAA_Row>
        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} />
              <EAA_Select disabled={disabled} displayBorder list={ExtendRule} value={returnInputValue(data.extend_rule)} onChange={data => this.changeData({ label: 'extend_rule', data })} />
            </EAA_ItemContainer>
            {errorAry[2] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇' />}
          </EAA_Item>
          <EAA_Item />
        </EAA_Row>

        <Supple disabled={disabled} data={JSON.parse(data.supple_data || '[]')} changeData={data => this.changeData({ label: 'supple_data', data: JSON.stringify(data) })} />

        <div style={{ display: 'flex', marginTop: 36, width: '100%', justifyContent: 'center', marginBottom: 40 }}>
          {mode === 'add' && !isCheck && <EAA_Btn text='取消' backgroundColor={leftColor} onClick={this._onClose} />}
          {mode === 'add' && !isCheck && <EAA_Btn text='確認' backgroundColor={rightColor} onClick={this.goToCheck} style={{ marginLeft: 16 }} />}
          {mode === 'add' && isCheck && <EAA_Btn text='返回編輯' backgroundColor={leftColor} onClick={this.goToEdit} />}
          {mode === 'add' && isCheck && <EAA_Btn text='確認新增' backgroundColor={(allRight && canSend) ? rightColor : 'gray'} onClick={this.add} style={{ marginLeft: 16 }} disabled={!allRight || !canSend} />}
          {mode === 'edit' && !isCheck && <EAA_Btn text='取消' backgroundColor={leftColor} onClick={this._onClose} />}
          {mode === 'edit' && !isCheck && <EAA_Btn text='確認' backgroundColor={rightColor} onClick={this.goToCheck} style={{ marginLeft: 16 }} />}
          {mode === 'edit' && isCheck && <EAA_Btn text='返回編輯' backgroundColor={leftColor} onClick={this.goToEdit} />}
          {mode === 'edit' && isCheck && <EAA_Btn text='確認修改' backgroundColor={(allRight && canSend) ? rightColor : 'gray'} onClick={this.edit} style={{ marginLeft: 16 }} disabled={!allRight || !canSend} />}
          {mode === 'view' && <EAA_Btn text='返回' backgroundColor={leftColor} onClick={this._onClose} />}
        </div>
      </div>
    );
  }

  render () {
    return (
      <Dialog
        PaperComponent={this.renderDialog}
        open={true}
      />
    );
  }
}

const mapStateToProps = state => ({
  ExtendReason: state.data.ExtendReason,
  ExtendRule: state.data.ExtendRule,
});
const mapDispatchToProps = dispatch => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(AddAndEdit);
